import styled from "styled-components";
import SettingsIcon from "@mui/icons-material/Settings";

export const GearIcon = styled(SettingsIcon)`
  margin-right: 1.5rem;
  cursor: pointer;
  color: white;
`;
